<template>
    <aside class="aside is-placed-left is-expanded dark:border-r dark:border-gray-800 dark:bg-gray-900/70 lg:dark:bg-gray-900 xl:dark:bg-gray-900/70 bg-gray-800">
        <div class="aside-tools">
            <div>
                <b class="font-black">Referex</b>app
            </div>
        </div>
        <div class="menu is-menu-main">
            <p class="menu-label">General</p>
            <ul class="menu-list">
                <li :class="{'active': $page.url.startsWith('/dashboard')}">
                    <a :href="route('dashboard')">
                        <span class="icon"><i class="mdi mdi-desktop-mac"></i></span>
                        <span class="menu-item-label">Dashboard</span>
                    </a>
                </li>
            </ul>
            <p class="menu-label">Management</p>
            <ul class="menu-list">
                <li class="--set-active-tables-html" :class="{'active': $page.url.startsWith('/campaigns')}">
                    <a :href="route('campaigns')">
                        <span class="icon"><i class="mdi mdi-newspaper-variant"></i></span>
                        <span class="menu-item-label">Campaigns</span>
                    </a>
                </li>
                <li class="--set-active-tables-html" :class="{'active': $page.url.startsWith('/referrers')}">
                    <a :href="route('referrers')">
                        <span class="icon"><i class="mdi mdi-account-group"></i></span>
                        <span class="menu-item-label">Influencers</span>
                    </a>
                </li>
            </ul>
            <p class="menu-label">Account</p>
            <ul class="menu-list">
                <li class="--set-active-tables-html" :class="{'active': $page.url.startsWith('/subscriptions')}">
                    <a :href="route('subscriptions')">
                        <span class="icon"><i class="mdi mdi-cash"></i></span>
                        <span class="menu-item-label">Subscription Plan</span>
                    </a>
                </li>
            </ul>
            <template v-if="$page.props.is_super_user">
                <p class="menu-label">Developer</p>
                <ul class="menu-list">
                    <li class="--set-active-tables-html" :class="{'active': $page.url.startsWith('/dev/dashboard')}">
                        <a :href="route('dev.dashboard')">
                            <span class="icon"><i class="mdi mdi-desktop-mac"></i></span>
                            <span class="menu-item-label">Dashboard</span>
                        </a>
                    </li>

                    <li class="--set-active-tables-html" :class="{'active': $page.url.startsWith('/dev/feedback')}">
                        <a :href="route('dev.feedback')">
                            <span class="icon"><i class="mdi mdi-bullhorn-outline"></i></span>
                            <span class="menu-item-label">Feedback</span>
                        </a>
                    </li>

                    <li class="--set-active-tables-html" :class="{'active': $page.url.startsWith('/dev/log-reader')}">
                        <a :href="'/dev/log-reader'">
                            <span class="icon"><i class="mdi mdi-math-log"></i></span>
                            <span class="menu-item-label">Log Reader</span>
                        </a>
                    </li>
                </ul>
            </template>

        </div>
    </aside>

</template>

<script>
export default {
    name: "SideMenu"
}
</script>

<style scoped>
.gradient {
    background: linear-gradient(90deg, #d53369 0%, #3E13A5 100%);
    /*background: radial-gradient(circle at 0% -25%,#FF8947 0%,#FF8354 0,#DA2C94 42%,#3E13A5 110%);*/
}
</style>
